import stackStyles from '../components/sections/stack-section/StackList.module.css'

// A "tone" is a Primer color bucket that a stack entry's vertical line segment
// is drawn in, matching its status icon's color. Shared by the effective-entry
// (`get-effective-entry-line-class`) and rebase (`rebase-state-line-class`)
// line-class helpers.
export type LineTone = 'default' | 'attention' | 'danger' | 'success' | 'done'

// Maps a tone to the class that sets the line color custom property on the
// `<li>`, so the inner `<a>::after` line segment can pick it up.
export const LINE_TONE_CLASS: Record<LineTone, string> = {
  default: stackStyles.lineDefault,
  attention: stackStyles.lineAttention,
  danger: stackStyles.lineDanger,
  success: stackStyles.lineSuccess,
  done: stackStyles.lineDone,
}
